// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"9a1bb283","278":"80dc100d","453":"3dac6228","660":"b9f6e899","701":"abb15b33","717":"f33bf6b0","879":"6938c98a"}[chunkId] + ".chunk.js";
};